import { Schema as S } from "effect";
import { EgkAttestationHandle } from "@ascleo/frontdesk-contracts/patient-info/egk-attestation";

/**
 * Check-In Request Schema
 *
 * Check in a patient for their appointment.
 */
export const CheckInRequestSchema = S.Struct({
  /** Patient ID (required) */
  patientId: S.String,
  /** Schedule/appointment ID (optional - if not provided, looks up today's appointments) */
  scheduleId: S.optional(S.String),
  /**
   * Opaque eGK attestation carried from the card read, if this flow had one.
   *
   * Supplying it is not authority: it is committed only by an actual schedule mutation to
   * `CHECKED_IN`, and the server re-derives every binding from its own record. A `SELECT_APPOINTMENT`
   * or `NO_APPOINTMENT` result leaves it uncommitted, so a client cannot turn a known patient ID into
   * patient-info access by asserting one here.
   */
  egkAttestation: S.optional(EgkAttestationHandle),
});

export type CheckInRequest = S.Schema.Type<typeof CheckInRequestSchema>;

